/**
 * "Orders changed - refetch now" signal between the FCM handler and the live
 * orders dashboard. A plain window event, so the dashboard does not have to
 * know where the signal came from (foreground push, service-worker push).
 */
export const ORDERS_CHANGED_EVENT = "tazty:orders-changed";

export type OrdersChangedDetail = {
  order_id?: string;
  status?: string;
};

const ORDER_MESSAGE_TYPES = new Set(["order_update", "order_refresh"]);

export const isOrderMessage = (data: any): boolean =>
  ORDER_MESSAGE_TYPES.has(String(data?.type ?? "").toLowerCase());

export const notifyOrdersChanged = (detail: OrdersChangedDetail = {}): void => {
  try {
    window.dispatchEvent(new CustomEvent<OrdersChangedDetail>(ORDERS_CHANGED_EVENT, { detail }));
  } catch {
    // very old browsers without CustomEvent - the periodic refresh still runs
  }
};
